import { Component } from '@angular/core';

@Component({
  selector: 'spark-core-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {
  constructor() {}
}
